// Akcje otwarte i zamknięte (rejestr akcji). Osobny moduł, żeby logika i PDF nie ciągnęły komponentów UI.
export enum ActionStatus {
  Open = 0,
  Closed = 1,
}

export interface ReportActionDto {
  id: string;
  reportId: string;
  participantNumber: string; // może zawierać kilka numerów, np. "01-005; KL-10-01"
  deviationDescription: string;
  identificationDate: string; // ISO
  status: ActionStatus;
  closedDate?: string; // ISO
  actionsTaken?: string;
  potentialDeviation: boolean;
  // kolumny z formatu klienta (SR-014)
  visitNumber?: string | null;
  categoryId?: number | null;
  responsiblePerson?: string | null;
  potentialSeriousFinding?: boolean;
  seriousBreach?: boolean;
  extendedFields?: boolean; // wysyłane przez rejestr: backend nadpisuje kolumny formatu tylko z tą flagą
  createdBy: string;
  created: string; // ISO
  edited: string; // ISO
  editedBy: string;
}
